const { useEffect, useState } = React;

function Hero() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        setIsVisible(true);
    }, []);

    return (
        <section id="home" className="relative w-full min-h-screen flex items-center overflow-hidden pt-24 sm:pt-28 pb-16 hero-shell section-shell">
            <div className="absolute inset-0 bg-gradient-to-br from-white via-blue-50 to-white opacity-70"></div>

            <div className="absolute top-10 left-[-80px] w-72 h-72 sm:w-96 sm:h-96 bg-blue-200 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob"></div>
            <div className="absolute top-24 right-[-90px] w-72 h-72 sm:w-96 sm:h-96 bg-blue-100 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-2s"></div>
            <div className="absolute -bottom-24 left-1/2 w-72 h-72 sm:w-96 sm:h-96 bg-blue-300 rounded-full mix-blend-multiply filter blur-3xl opacity-15 animate-blob animation-delay-4s"></div>

            <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
                    <div className="lg:col-span-7 text-center lg:text-left">
                        <div className={`inline-flex items-center gap-2 section-kicker mb-6 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-2'} transition-all duration-700`}>
                            <span className="inline-flex h-2 w-2 rounded-full bg-emerald-500"></span>
                            Smart property platform
                        </div>

                        <h1 className={`text-4xl sm:text-5xl lg:text-6xl leading-[1.04] font-extrabold mb-5 section-title transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
                            <span className="text-gray-900">
                                Search smarter.
                            </span>{" "}
                            <span className="bg-gradient-to-r from-blue-700 via-blue-600 to-emerald-500 bg-clip-text text-transparent">
                                Book viewings faster.
                            </span>
                        </h1>

                        <p className={`text-base sm:text-lg text-gray-600 max-w-2xl mx-auto lg:mx-0 mb-8 transition-all duration-1000 delay-200 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
                            BEASMAR helps clients discover great homes and lets realtors manage listings and appointments in one clean workflow.
                        </p>

                        <div className={`flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center lg:justify-start transition-all duration-1000 delay-400 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
                            <a href="customer.html" className="btn-primary btn-lg group w-full sm:w-auto">
                                <span className="relative flex items-center justify-center gap-2">
                                    Start as a Client
                                    <svg className="w-5 h-5 transform group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                                    </svg>
                                </span>
                            </a>

                            <a href="agent.html" className="btn-secondary btn-lg group w-full sm:w-auto">
                                <span className="relative flex items-center justify-center gap-2">
                                    Start as a Realtor
                                    <svg className="w-5 h-5 transform group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                                    </svg>
                                </span>
                            </a>

                            <a href="agent.html?tab=plans" className="w-full sm:w-auto px-6 py-4 rounded-[14px] text-sm font-semibold text-gray-700 bg-white/70 border border-gray-200 hover:bg-white transition">
                                See plans
                            </a>
                        </div>

                        <div className={`mt-8 flex flex-wrap items-center justify-center lg:justify-start gap-x-6 gap-y-3 text-sm text-gray-600 transition-all duration-1000 delay-600 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
                            {[
                                "Verified realtors",
                                "Real-time booking",
                                "Clear media & listings",
                            ].map((item) => (
                                <div key={item} className="flex items-center gap-2">
                                    <span className="inline-flex h-5 w-5 items-center justify-center rounded-full bg-emerald-50 border border-emerald-100">
                                        <svg className="w-3 h-3 text-emerald-600" fill="currentColor" viewBox="0 0 20 20">
                                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                        </svg>
                                    </span>
                                    {item}
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="lg:col-span-5">
                        <div className={`relative transition-all duration-1000 delay-300 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
                            <div className="absolute -inset-4 bg-gradient-to-br from-blue-600/20 to-emerald-400/10 rounded-3xl blur-2xl"></div>
                            <div className="relative surface-card p-7 sm:p-8">
                                <div className="flex items-center justify-between mb-6">
                                    <div className="flex items-center gap-3">
                                        <img
                                            src="assets/beasmar-logo.jpg"
                                            alt="BEASMAR logo"
                                            className="h-10 w-10 rounded-2xl object-cover border border-blue-200/60 bg-white"
                                        />
                                        <div>
                                            <div className="font-bold text-gray-900">BEASMAR</div>
                                            <div className="text-sm text-gray-500">Preview</div>
                                        </div>
                                    </div>
                                    <div className="px-3 py-1 rounded-full text-xs font-semibold bg-emerald-50 text-emerald-700 border border-emerald-100">
                                        Live availability
                                    </div>
                                </div>

                                <div className="space-y-4">
                                    {[
                                        { title: "Explore listings", desc: "Filter by price, location, and type." },
                                        { title: "Book a viewing", desc: "Pick a slot and confirm instantly." },
                                        { title: "Manage as a realtor", desc: "Upload media, approve bookings, track performance." },
                                    ].map((row) => (
                                        <div key={row.title} className="flex items-start gap-3">
                                            <div className="mt-1 h-9 w-9 rounded-xl bg-gradient-to-br from-blue-600/15 to-blue-400/10 border border-blue-200/60 flex items-center justify-center">
                                                <span className="h-2 w-2 rounded-full bg-emerald-500"></span>
                                            </div>
                                            <div>
                                                <div className="font-semibold text-gray-900">{row.title}</div>
                                                <div className="text-sm text-gray-600">{row.desc}</div>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                <div className="mt-7 grid grid-cols-3 gap-3">
                                    {[
                                        { label: "Fast", value: "Minutes" },
                                        { label: "Trusted", value: "Verified" },
                                        { label: "Support", value: "Responsive" },
                                    ].map((stat) => (
                                        <div key={stat.label} className="rounded-2xl border border-gray-200/80 bg-white/60 p-3 text-center">
                                            <div className="text-sm font-bold text-gray-900">{stat.value}</div>
                                            <div className="text-[11px] text-gray-500">{stat.label}</div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Hero;
